import { Component, OnInit, QueryList } from "@angular/core";
import { DeviceCheckService } from "../../survey/shared/services/device-check.service";
import { TabViewModule } from "primeng/tabview";
import { PermissionsService } from "src/app/shared/services/permissions.service";
import { PermissionsEnum } from "src/app/shared/Models/enums/PermissionsEnum";

@Component({
  selector: "app-admin-panel-settings",
  templateUrl: "./admin-panel-settings.component.html",
  styleUrls: ["./admin-panel-settings.component.scss"],
})
export class AdminPanelSettingsComponent {
  constructor(
    protected deviceCheckService: DeviceCheckService,
    private permissionsService: PermissionsService
  ) {}

  get canViewBulkSettings(): boolean {
    return this.permissionsService.allowed(PermissionsEnum.BulkConfiguration);
  }

  get canViewGeneralSettings(): boolean {
    return this.permissionsService.allowed(PermissionsEnum.GeneralSettings);
  }
}
